// extracted by mini-css-extract-plugin
export default {"wrapper":"csv-viewer_wrapper__VNc7H","previewContainer":"csv-viewer_previewContainer__Qv9v7"};